<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    :okButtonProps="{ props: {disabled: disableSubmit} }"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('关闭')">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form" >
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('平台类型')">
          <j-dict-select-tag :disabled="disableSubmit" :placeholder="$t('请输入平台类型')" :triggerChange="true" v-decorator="['platformType', {rules: [{required: true,message: $t('请选择平台类型')}]}]"  dictCode="platform_type" @change="changePlatformType" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
          :label="$t('应用名称')">
          <a-input :placeholder="$t('请输入应用名称')" v-decorator="['appName', validatorRules.appName]" :readOnly="disableSubmit" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="form.getFieldValue('platformType') == 11?'APP Secret': $t('应用ID')" :extra="form.getFieldValue('platformType') == 2?$t('请输入移动平台的产品ID'): ''">
          <a-input :placeholder="form.getFieldValue('platformType') == 11?$t('请输入APP Secret'):$t('请输入应用ID')" v-decorator="['appId', validatorRules.appId]" :readOnly="disableSubmit" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="form.getFieldValue('platformType') == 11?'APP Key': $t('应用Key')" v-show="form.getFieldValue('platformType') != 2">
          <a-input :placeholder="form.getFieldValue('platformType') == 11?$t('请输入APP Key'):$t('请输入应用Key')" v-decorator="['appKey', validatorRules.appKey]" :readOnly="disableSubmit" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('产品ID')" v-show="form.getFieldValue('platformType') != 2">
          <a-input :placeholder="$t('请输入产品ID')" v-decorator="['productId', validatorRules.productId]" :readOnly="disableSubmit" @change="changeProductId" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="masterKey" v-show="form.getFieldValue('platformType') != 1 && form.getFieldValue('platformType') != 3">
          <a-input :placeholder="$t('请输入masterKey')" v-decorator="['masterKey', validatorRules.masterKey]" :readOnly="disableSubmit" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          has-feedback
          :label="$t('推送地址')">
          <a-input :placeholder="$t('请输入推送地址')" v-decorator="['url', validatorRules.url]" :readOnly="disableSubmit" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('激活状态')" v-show="model.id">
          <j-dict-select-tag :showChoose="false" :placeholder="$t('请输入激活状态')" :triggerChange="true" v-decorator="['appActive', {initialValue: 1}]"  dictCode="app_active" :disabled="disableSubmit" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :label="$t('备注')">
          <a-textarea :placeholder="$t('请输入备注')" v-decorator="['remark', {}]" :rows="4" :readOnly="disableSubmit" />
        </a-form-item>
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
  import { httpAction, postAction } from '@/api/manage'
  import {duplicateCheck } from '@/api/api'
  import pick from 'lodash.pick'
  import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
  import { isEmptyObject } from '@/utils/validate'
  export default {
    name: 'MeterAppinfoModal',
    components: {
      JDictSelectTag
    },
    data () {
      return {
        visible: false,
        disableSubmit: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        platformType: '',
        form: this.$form.createForm(this),
        url: {
          add: "/jeecg-charge/meter/meterAppinfo/add",
          edit: "/jeecg-charge/meter/meterAppinfo/edit",
          queryById: "/jeecg-charge/meter/meterAppinfo/queryById"
        },
      }
    },
    computed: {
      // i18n：标题/校验消息使用 computed 以响应语言切换
      title () {
        return this.$t('操作')
      },
      validatorRules(){
        return {
          appName: {rules:
            [{ required: true, message: this.$t('请输入应用名称')},
            {validator: this.validateAppName}
          ]},
          appId: {
            rules: [{
              required: true, message: this.$t('请输入应用ID'),},
              {validator: this.validateAppId}
            ]
          },
          appKey: {
            rules: [{
              required: false, message: this.$t('请输入应用key')},
              {validator: this.validateAppKey}
            ]
          },
          productId: {
            rules: [
              {required: false, message: this.$t('请输入正确的产品ID')},
            ]
          },
          masterKey: {
            rules: [{
              required: false, message: this.$t('请输入masterKey')},
              {validator: this.validateMasterKey}
            ]
          },
        }
      },
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'customerId','url','platformType','appName','appId','appKey','productId','masterKey','appActive','remark'))
          if(!isEmptyObject(record)) {
            this.changePlatformType(this.model.platformType)
          }
        });
      },
      close () {
        this.$emit('close');
        this.resetData();
        this.visible = false;
      },
      resetData() {
        this.platformType = ''
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
              method = 'put';
            }
            let formData = Object.assign(this.model, values);
            //时间格式化
            console.log(formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
      // 查询应用名称是否重复
      validateAppName(rule, value, callback){
        if(!value){
          callback()
        }else{
          var params = {
            tableName: 'infrared_appinfo',
            fieldName: 'app_name',
            fieldVal: value,
            dataId: this.model.id
          };
          duplicateCheck(params).then((res) => {
            if (res.success) {
              callback()
            } else {
              callback(this.$t("应用已存在!"))
            }
          })
        }
      },
      // 查询应用名称是否重复
      validateAppId(rule, value, callback){
        let platformType = this.platformType;
        console.log("platformType: "+platformType)
        // 电信AEP平台中appId和appKey可以重复，所以不进行判断
        if(!value||platformType == 11){
          callback()
        }else{
          var params = {
            tableName: 'infrared_appinfo',
            fieldName: 'app_id',
            fieldVal: value,
            dataId: this.model.id
          };
          duplicateCheck(params).then((res) => {
            if (res.success) {
              // 如果选择的运营商是电信OceanCon,或者联通
              if(platformType === '1'||platformType === '3') {
                this.changeDefaultUrl()
              }
              callback()
            } else {
              callback(this.$t("应用ID已存在!"))
            }
          })
        }
      },
      validateMasterKey(rule, value, callback) {
        if(!value){
          callback()
        }else{
          var params = {
            tableName: 'infrared_appinfo',
            fieldName: 'master_key',
            fieldVal: value,
            dataId: this.model.id
          };
          duplicateCheck(params).then((res) => {
            if (res.success) {
              callback()
            } else {
              callback(this.$t("masterKey已存在!"))
            }
          })
        }
      },
      validateProduceId(rule, value, callback) {
        if(!value){
          callback()
        }else{
          var params = {
            tableName: 'infrared_appinfo',
            fieldName: 'product_id',
            fieldVal: value,
            dataId: this.model.id
          };
          duplicateCheck(params).then((res) => {
            if (res.success) {
              callback()
            } else {
              callback(this.$t("产品ID已存在!"))
            }
          })
        }
      },
      validateAppKey(rule, value, callback) {
        let platformType = this.platformType;
        console.log("当前platformType: "+platformType)
        // 电信AEP平台中appId和appKey可以重复，所以不进行判断
        if(!value||platformType == 11){
          callback()
        }else{
          var params = {
            tableName: 'infrared_appinfo',
            fieldName: 'app_key',
            fieldVal: value,
            dataId: this.model.id
          };
          duplicateCheck(params).then((res) => {
            if (res.success) {
              callback()
            } else {
              callback(this.$t("应用key已存在!"))
            }
          })
        }
      },
      changeProductId(e) {
        console.log(e)
        if(this.platformType === '11') {
          this.$nextTick(()=> {
            this.changeDefaultUrl()
          })
        }
      },
      // 改变运营商
      changePlatformType(e) {
        console.log(this.model.id)
        this.platformType = e
        console.log(this.model.id);
        if(!this.model.id) {
          // 新增的时候设置默认的推送地址和设置默认的appId和appKey
          this.changeDefaultUrl()
          this.changeDefaultAppIdAndAppKey()
        }
        this.changevalidateRules()
      },
      // 根据显示不同的默认推送地址
      changeDefaultUrl() {
        console.log("设置默认值")
        let data = {
            1: '',
            11: '',
            2: 'http://59.110.50.73:8080/jeecg-boot/model/infraredCommand/updateDeviceData_onenet.do',
            3: ''
          }
          if(this.platformType === '11'&&this.form.getFieldValue('productId')) {
            data['11'] = 'http://59.110.50.73:8989/xf/nbiot/aep/'+this.form.getFieldValue('productId')
          }
          if(this.platformType === '1'&&this.form.getFieldValue('appId')) {
            data['1'] = 'http://59.110.50.73:8989/xf/nbiot/na/'+this.form.getFieldValue('appId')
          }
          if(this.platformType === '3'&&this.form.getFieldValue('appId')) {
            data['3'] = 'http://59.110.50.73:8989/xf/nbiot/unicom/'+this.form.getFieldValue('appId')
          }
          this.form.setFieldsValue({ url: data[this.platformType]})
      },
      changeDefaultAppIdAndAppKey() {
        console.log("设置默认的appId和appKey")
        let platformType = this.platformType
        console.log(platformType)
        if(platformType == 11) {
          this.form.setFieldsValue({ appId: 'aabsOn3vm0'})
          this.form.setFieldsValue({ appKey: '9xiCkobR1rl'})
        }else{
          this.form.setFieldsValue({ appId: '',appKey: ''})
        }
      },
      changevalidateRules() {
        let platformType = this.platformType
        let arr = []
        if(platformType == 2) {
          arr = ['appKey','productId']
          arr.forEach((item, index, arr) => {
            this.validatorRules[item].rules[0].required = false
          })
          this.validatorRules.masterKey.rules[0].required = true
        }else{
          arr = ['appKey','productId']
          arr.forEach((item, index, arr) => {
            this.validatorRules[item].rules[0].required = true
          })
          console.log(platformType === '1')
          if(platformType == 1 || platformType == 3){
            this.validatorRules.masterKey.rules[0].required = false
          }else{
            arr.push('masterKey')
            this.validatorRules.masterKey.rules[0].required = true
          }
        }
        if(platformType == 11) {
          this.validatorRules.productId.rules[0].pattern = /^-?\d+$/
        }else{
          this.validatorRules.productId.rules[0].pattern = ''
        }
        this.form.validateFields(arr, { force: true });
      },
    }
  }
</script>